__turbopack_context__.v({
  "content_title": "common-module-scss-module__02p0Qq__content_title",
  "drawer_list": "common-module-scss-module__02p0Qq__drawer_list",
  "drawer_list_item": "common-module-scss-module__02p0Qq__drawer_list_item",
  "etc_textarea": "common-module-scss-module__02p0Qq__etc_textarea",
  "flow_header": "common-module-scss-module__02p0Qq__flow_header",
  "flow_title": "common-module-scss-module__02p0Qq__flow_title",
  "intro-fadein": "common-module-scss-module__02p0Qq__intro-fadein",
  "intro_vh": "common-module-scss-module__02p0Qq__intro_vh",
  "main_cta_space": "common-module-scss-module__02p0Qq__main_cta_space",
  "main_full_page_with_nav_layout": "common-module-scss-module__02p0Qq__main_full_page_with_nav_layout",
  "main_layout": "common-module-scss-module__02p0Qq__main_layout",
  "section_list_item": "common-module-scss-module__02p0Qq__section_list_item",
  "section_title": "common-module-scss-module__02p0Qq__section_title",
});
